export default {"src":"/_next/static/media/buyer-guide2.8b11639d.svg","height":398,"width":538,"blurWidth":0,"blurHeight":0};